// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"61133e77","581":"b7391be6","777":"ba35c125"}[chunkId] + ".chunk.js";
};